export default __webpack_public_path__ + "static/media/cash_manage.3b7de99b.jpg";